import RedebitModelBase from '../_generated/modelBases/redebit-model-base';

export default class RedebitModel extends RedebitModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
